import L from "leaflet";

const ICON_W = 34;
const ICON_H = 40;

/** Höhe des Windrads über seinem Punkt – das Icon ist unten verankert und ragt so weit nach oben */
export const WINDMILL_ICON_HEIGHT = ICON_H;

function windmillHtml(selected: boolean): string {
  const glow = selected
    ? "filter:drop-shadow(0 0 5px rgba(255,255,255,0.95)) drop-shadow(0 0 2px rgba(255,255,255,0.7));"
    : "";

  return `<img src="/logo.svg" width="${ICON_W}" height="${ICON_H}" style="display:block;${glow}"/>`;
}

/**
 * Je Zustand genau ein Icon. Ein neues Icon bei jedem Rendern ließe Leaflet den Marker jedes Mal
 * neu aufbauen (`setIcon`): Das `<img>` würde ersetzt und das Logo neu geladen – der Marker
 * blinkt bei jeder Kartenbewegung.
 */
const ICONS = new Map<boolean, L.DivIcon>();

export function createWindmillIcon(selected = false): L.DivIcon {
  const cached = ICONS.get(selected);
  if (cached) return cached;
  const icon = L.divIcon({
    html: windmillHtml(selected),
    className: "",
    iconSize: [ICON_W, ICON_H],
    iconAnchor: [ICON_W / 2, ICON_H],
    popupAnchor: [0, -ICON_H],
  });
  ICONS.set(selected, icon);
  return icon;
}
